const root = "_35srshos6p";
const wrapper = "_35sw1cy45cd";
const container = "_35scte5sgz";
const label = "_35slor9h26";
const chevron = "_35scormb56";

export { chevron, container, label, root, wrapper };
import "./container.facit.style.linaria.module.css";
//# sourceMappingURL=container.facit.style.js.map
